import { render, staticRenderFns } from "./updatehistory.vue?vue&type=template&id=bbe3d2e4&scoped=true&"
import script from "./updatehistory.vue?vue&type=script&lang=js&"
export * from "./updatehistory.vue?vue&type=script&lang=js&"
import style0 from "./updatehistory.vue?vue&type=style&index=0&id=bbe3d2e4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe3d2e4",
  null
  
)

export default component.exports